/* eslint-disable */
import { React, useEffect, useRef, useState } from 'react';
import { useAuth } from '../../Hooks/useAuth';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';
import { SSOLoginButton } from './ssoLoginButton';
import './login.scss';
import darpanIcon from '../../Assets/images/svg/darpan_icon.svg';
import puzzleLoader from '../../Assets/images/svg/loading puzzle.gif';
import {
  WELCOME_TO_DARPAN,
  DARPAN_TOOL_TAGLINE,
} from '../../Constants/strings';
import { configureUserData } from './userData';
import AxiosWrapper from '../../Api/http/AxiosWrapper';
import { logError } from '../../Utils/logger';
import lottie from 'lottie-web';
import { menuItems } from '../../Layouts/SideBar/sidebar';

function LogInPage() {
  const { login, loggedIn } = useAuth();
  const Wrapper = new AxiosWrapper();
  const [animationData, setAnimationData] = useState(null);
  const [isLoginLoading, setIsLoginLoading] = useState(false);
  const animationContainer = useRef(null);

  useEffect(() => {
    import('../../Assets/images/json/dar_man_monitoring_dashboard.json').then(
      ({ default: animationData }) => {
        setAnimationData(animationData);
      },
    );
  }, []);

  // AuthProvider already verifies any existing session on mount; just react to
  // its result here instead of calling login() again (which caused duplicate
  // concurrent "users" API calls).
  useEffect(() => {
    if (loggedIn) {
      navigateToHome();
    }
  }, [loggedIn]);

  useEffect(() => {
    if (animationData) {
      lottie.loadAnimation({
        container: animationContainer.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData,
      });
    }
  }, [animationData]);

  const navigate = useNavigate();
  const handleLogin = async (googleData) => {
    // Handle success case of oAuth login
    setIsLoginLoading(true);

    try {
      if (googleData) {
        Wrapper.authenticate(googleData.access_token);
        await configureUserData(googleData);

        const data = await login();
        if (data) {
          navigateToHome();
        } else {
          throw new Error('SSO Login Failed');
        }
      } else {
        setIsLoginLoading(false);
      }
    } catch (error) {
      logError('SSO Login Failed', error);
      setIsLoginLoading(false);
    }
  };

  const findMenuStateFromPath = (path, menuItems) => {
  for (const menuItem of menuItems) {
    // Check main menu items
    if (menuItem.link === path) {
      return {
        activeMenuItem: menuItem.id.toString(),
        activeSubmenuItem: null,
        activeSubmenuOption: null
      };
    }

    // Check submenu items
    if (menuItem.submenuItems) {
      for (const submenuItem of menuItem.submenuItems) {
        if (submenuItem.link === path) {
          return {
            activeMenuItem: menuItem.id.toString(),
            activeSubmenuItem: submenuItem.id.toString(),
            activeSubmenuOption: null
          };
        }

        // Check submenu options
        if (submenuItem.submenuOptions) {
          for (const option of submenuItem.submenuOptions) {
            if (path.includes(option.link)) {
              return {
                activeMenuItem: menuItem.id.toString(),
                activeSubmenuItem: submenuItem.id.toString(),
                activeSubmenuOption: option.id.toString()
              };
            }
          }
        }
      }
    }
  }
  return null;
};

  const navigateToHome = () => {
    const redirectPath = localStorage.getItem('redirectPath');
    
    if (redirectPath) {
      const menuState = findMenuStateFromPath(redirectPath, menuItems);
      if (menuState) {
        localStorage.setItem('activeMenuItem', menuState.activeMenuItem);        
        if (menuState.activeSubmenuItem) {
          localStorage.setItem('activeSubmenuItem', menuState.activeSubmenuItem);
        }
        if (menuState.activeSubmenuOption) {
          localStorage.setItem('activeSubmenuOption', menuState.activeSubmenuOption);
        }
      } else {
        // Default to home if path not found in menu structure
        localStorage.setItem('activeMenuItem', '1');
        navigate('/home');
      }
      
      localStorage.removeItem('redirectPath');
      navigate(redirectPath);
    } else {
      localStorage.setItem('activeMenuItem', '1');
      navigate('/home');
    }
  };

  const handleFailure = () => {
    // Handle failure case of oAuth login
    logError('SSO Login Failed');
    setIsLoginLoading(false);
  };

  const renderSSOLoginButton = () => {
    return (
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
        <SSOLoginButton
          onSuccess={handleLogin}
          onError={handleFailure}
          disabled={isLoginLoading}
        />
      </GoogleOAuthProvider>
    );
  };

  const renderPuzzleLoader = () => (
    <div className="login-loader-overlay" role="status" aria-live="polite">
      <img src={puzzleLoader} alt="Signing you in" className="login-puzzle-loader" />
    </div>
  );

  const renderWelcomText = () => {
    return (
      <div className="welcome-display-on-mobile">
        <img className="darpan-icon" src={darpanIcon} alt="Darpan Icon" />
        <div className="welcome-text-mobile">{WELCOME_TO_DARPAN}</div>
        <div className="tool-tagline-mobile">{DARPAN_TOOL_TAGLINE}</div>
      </div>
    );
  };

  return (
    <div className="container">
      {isLoginLoading && renderPuzzleLoader()}
      <div className="left-panel">
        {renderWelcomText()}

        <div ref={animationContainer} className="left-panel-image"></div>

        <div className="login-display-on-mobile">
          <div className="sign-in-button">{renderSSOLoginButton()}</div>
        </div>
      </div>
      <div className="right-panel">
        <div className="content-area">
          {renderWelcomText()}
          <div className="sign-in-button">{renderSSOLoginButton()}</div>
        </div>
      </div>
    </div>
  );
}

LogInPage.propTypes = {};

export default LogInPage;
